import { INeoAction } from './../Actions.interface';
import { STATIC_ACTIONS } from '../../Constants/Actions.constants';
import { getLocalLanguage } from './languageDefaults';
import { LanguagesEnum } from '~/Constants/Languages.constants';

const INITIAL_STATE = getLocalLanguage(navigator.language || (navigator as any).userLanguage);

export default (state: LanguagesEnum = INITIAL_STATE, action: INeoAction) => {
  if (action.type && action.type === STATIC_ACTIONS.CHANGE_LANGUAGE) {
    return action.payload;
  }

  return state;
};
